<template>
  <div class="template_box">
    <div class="temp_t">
      <div>
        <div class="temp_t_btn" @click="openTemplateDialog">新增模板</div>
        <div class="temp_classi_add" @click="addClassify('')">新增分类</div>
      </div>
      <div class="temp_t_search">
        <el-input
          placeholder="模板名称或描述"
          v-model="searchForm.keyword"
        >
        </el-input>
        <el-select v-model="searchForm.user_id" placeholder="账号" v-if="userRole.key != 'employee'">
          <el-option
            v-for="item in subAccountList"
            :key="item.id"
            :label="`${item.nickname}${item.id == $store.state.userInfo.id ? '(我)' : ''}`"
            :value="item.id">
          </el-option>
        </el-select>
        <el-button class="search_btn" @click="setPage(1)">
          搜索 
        </el-button>
      </div>
    </div>
    <div class="temp_classi">
      <div
        class="temp_classi_item"
        :class="{ active: !searchForm.category_id || searchForm.category_id == '' }"
        @click="changeCategory('')"
      >全部</div>
      <div
        v-for="(item, index) in classifyList"
        class="temp_classi_item"
        :class="{ active: parentClassify.id == item.id }"
        @click="changeCategory(item)"
      >
        {{ item.name }} <span>{{ item.num }}</span> 
        <el-dropdown @command="handleCategoryEdit($event, item)">
          <span class="el-dropdown-link">
            <i class="el-icon-more-outline" v-if="parentClassify.id == item.id"></i>
          </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="delete">删除</el-dropdown-item>
          <el-dropdown-item command="rename">重命名</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </div>
    </div>
    <div class="temp_classi" v-if="parentClassify.children">
      <div
        class="temp_classi_item"
        :class="{ active: searchForm.category_id == parentClassify.id }"
        @click="changeCategory(parentClassify)"
      >全部</div>
      <div
        v-for="(item, index) in parentClassify.children"
        class="temp_classi_item"
        :class="{ active: searchForm.category_id == item.id }"
        @click="changeCategory(item)"
      >
        {{ item.name }} <span>{{ item.num }}</span> 
        <el-dropdown @command="handleCategoryEdit($event, item)">
          <span class="el-dropdown-link">
            <i class="el-icon-more-outline" v-if="searchForm.category_id == item.id"></i>
          </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="delete">删除</el-dropdown-item>
          <el-dropdown-item command="rename">重命名</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </div>
    </div>
    <!-- <el-checkbox-group v-model="multipleSelection" class="material_r_grid" @change="handleSelectionChange" v-infinite-scroll="gridScrollBottom" :infinite-scroll-disabled="tableLoading || gridNoMore" v-else> -->
    <div class="temp_r_grid">
      <div v-for="item in tableData" class="temp_grid_item">
        <div class="temp_printtype">{{ item.type == 1 ? '单印花' : '多印花' }}</div>
        <div class="temp_printtype" style="top: 38px" v-if="item.is_public == 1">已公开</div>
        <div class="temp-gridbox">
          <div class="outimg_box">
            <el-image
              class="temp-grid-img"
              :src="item.images[0].image_url"
              fit="contain"
            ></el-image>
          </div>
          <div class="side_img_box">
            <div class="side_img_out" v-for="item in item.images.slice(0,4)">
              <img :src="item.image_url" />
            </div>
          </div>
          <div class="temp_grid_mask">
            <!-- <el-checkbox :label="item" :key="item.id"></el-checkbox> -->
            <div class="mask_opratebox">
              <img src="@/assets/images/m-edit.png" v-if="userPermission(item.user.id)" @click="editSoleFolder(item.id)" />
              <img src="@/assets/images/m-copy.png" v-if="userPermission(item.user.id)" @click="copyTemplate(item.id)" />
              <!-- <img src="@/assets/images/m-share.png" v-if="userPermission(item.user.id)" @click="specifyShared(item)" /> -->
              <!-- <img src="@/assets/images/m-delete.png" v-if="userPermission(item.user.id)" @click="batchDeletion(item.id)" /> -->
              <el-dropdown>
                <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item disabled>@{{item.user.nickname}}</el-dropdown-item>
                  <el-dropdown-item v-if="userPermission(item.user.id)" @click.native="copyTemplate(item.id)">创建副本</el-dropdown-item>
                  <el-dropdown-item v-if="userPermission(item.user.id)" @click.native="handleRemoveTemp(item.id, item.category_id)">移动到</el-dropdown-item>
                  <el-dropdown-item v-if="userPermission(item.user.id)" @click.native="specifyShared(item)">分享给</el-dropdown-item>
                  <el-dropdown-item v-if="userPermission(item.user.id)" @click.native="handleTemPubic(item.id, item.is_public)">{{item.is_public ? '取消公开' : '设为公开'}}</el-dropdown-item>
                  <el-dropdown-item v-if="userPermission(item.user.id)" @click.native="batchDeletion(item.id)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="mask_textbox">
              <div class="mask_time">
                印刷大小：
                <span v-for="size in item.sizes">
                  <span style="margin-right: 4px;" v-for="cutpiece in size.cutpieces">
                    {{size.size}}-{{cutpiece.name}}:{{ cutpiece.width }}*{{ cutpiece.height }}cm
                  </span>
                </span>
              </div>
              <div class="mask_time">
                尺码规格：<span v-for="size in item.sizes">{{size.size}}</span>
              </div>
              <div class="mask_time">
                颜色规格：<span class="mask_color"
                  v-for="color in item.colors"
                  :style="{ background: color.hex_value }"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="temp_outname">
          {{ item.name }} 
          <i class="el-icon-edit-outline" v-if="userPermission(item.user.id)" @click="editTemplateName(item.id)"></i>
        </div>
      </div>
      <!-- <div v-if="tableLoading" style="width: 100%;font-size: 14px;text-align: center;color: #ccc">加载中...</div> -->
    </div>
    <el-pagination
      class="main_pagination"
      background
      layout="prev, pager, next"
      :total="tableTotal"
      @current-change="setPage"
      :current-page.sync="searchForm.page"
      :page-size="searchForm.limit"
    >
    </el-pagination>
    <el-drawer
      class="main_drawer"
      title="新增模版"
      :visible.sync="addDrawer"
      direction="rtl"
      :wrapperClosable="false"
      :show-close="false"
    >
      <div class="main_drawer_body">
        <el-form label-position="top" :model="ruleForm" :rules="rules" ref="druleForm">
          <el-form-item label="商品套图名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入商品套图的名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="模板分组" prop="group">
            <el-cascader v-model="ruleForm.group" :options="classifyList" :props="classifyProps" placeholder="请选择" style="width: 100%;">
            </el-cascader>
          </el-form-item>
          <el-form-item label="轮播图尺寸" prop="width">
            <div class="sizeform_box">
              <el-input-number v-model="ruleForm.width" :controls="false" placeholder="W" :max="2048">
              </el-input-number>
              <img src="@/assets/images/link.png" style="margin: 0 2%" />
              <el-input-number v-model="ruleForm.height" :controls="false" placeholder="H" :max="2048">
              </el-input-number>
              <div class="sizeselect_box">
                <span style="flex-shrink: 0">推荐</span>
                <div class="size_box">
                  <div class="size_item" @click="ruleForm.width=1000,ruleForm.height=1000">
                    <img src="@/assets/images/temu.png" /> 1000*1000px
                  </div>
                  <div class="size_item" @click="ruleForm.width=1340,ruleForm.height=1785">
                    <img src="@/assets/images/temu.png" /> 1340*1785px
                  </div>
                </div>
                <el-dropdown trigger="click">
                  <el-button class="size_item">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu
                    slot="dropdown"
                    style="min-width: 247px;"
                  >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=2000,ruleForm.height=2000">
                        <div  class="size_box1">
                          <img src="@/assets/images/amazon.png" />
                          <p>Amazon</p>
                        </div>
                        <p>2000*2000px | 1:1</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=1000,ruleForm.height=1000">
                        <div  class="size_box1">
                          <img src="@/assets/images/temu.png" />
                          <p>TEMU 通用</p>
                        </div>
                        <p>1000*1000px | 1:1</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=1340,ruleForm.height=1785">
                        <div  class="size_box1">
                          <img src="@/assets/images/temu.png" />
                          <p>TEMU 服装</p>
                        </div>
                        <p>1340*1785px | 3:4</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=2048,ruleForm.height=2048">
                        <div  class="size_box1">
                          <img src="@/assets/images/shopify.png" />
                          <p>Shopify</p>
                        </div>
                        <p>2048*2048px | 1:1</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=1024,ruleForm.height=1024">
                        <div  class="size_box1">
                          <img src="@/assets/images/tiktok.png" />
                          <p>Tiktok Shop</p>
                        </div>
                        <p>1024*1024px | 1:1</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=2000,ruleForm.height=2000">
                        <div  class="size_box1">
                          <img src="@/assets/images/shein.png" />
                          <p>SHEIN</p>
                        </div>
                        <p>2000*2000px | 1:1</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=1600,ruleForm.height=1600">
                        <div  class="size_box1">
                          <img src="@/assets/images/aliexpress.png" />
                          <p>AliExpress</p>
                        </div>
                        <p>1600*1600px | 1:1</p>
                      </div></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><div class="size_option" @click="ruleForm.width=800,ruleForm.height=800">
                        <div  class="size_box1">
                          <img src="@/assets/images/1688.png" />
                          <p>阿里巴巴</p>
                        </div>
                        <p>800*800px | 1:1</p>
                      </div></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="颜色信息" prop="color">
            <el-select
              v-model="colors"
              multiple
              filterable
              remote
              placeholder="请选择颜色"
              :remote-method="getColorList"
              :loading="colorloading"
            >
              <el-option
                v-for="item in colorList"
                :key="item.id"
                :label="item.name_zh"
                :value="item.id"
              >
                {{ item.name_zh
                }}<span
                  :style="{ background: item.hex_value }"
                  class="color_label"
                ></span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="裁件分辨率 DPI" prop="dpi">
            <el-select
              v-model="ruleForm.dpi"
              placeholder="请选择分辨率"
            >
              <el-option
                v-for="item in dpiList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="main_drawer_footer">
        <el-button
          class="drawer_confirm"
          @click="handleSubmitForm"
          >确 定</el-button
        >
        <el-button class="drawer_cancel" @click="addDrawer=false">取 消</el-button>
      </div>
    </el-drawer>
    <!-- 指定共享弹窗 -->
    <specify-share ref="specifyShare" pageType="template" :list="emitChildData" />
    
    <el-dialog class="main_dialog" :show-close="false" :title="classiForm.id ? '编辑分类' : '新增分类'" width="470px" :visible.sync="dialogClassiVisible">
      <el-form :model="classiForm" label-position="top" hide-required-asterisk>
        <el-form-item label="父级分类" prop="parent_id" v-if="!classiForm.id">
          <el-select v-model="classiForm.parent_id" placeholder="请选择">
            <el-option
              v-for="item in classifyList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组名称" prop="name">
          <el-input v-model="classiForm.name" placeholder="请填写分组名称"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="dialog_confirm" size="small" @click="handleClassifyConfirm">确 定</el-button>
      <el-button class="dialog_cancel" size="small" @click="dialogClassiVisible = false">取 消</el-button>
    </el-dialog>
  </div>
</template>
<script>
import {
  categoryGetList,
  categoryCreate,
  categoryUpdate,
  categoryDelete,
  colorGetList,
  templateGetList,
  templateDelete,
  templateUpdate,
  templateCopy,
  templateRemoveCateg,
  templateUpdatePublic
} from "@/api/template";
import { allSubGetList } from '@/api/subaccount'
import SpecifyShare from "@/components/SpecifyShare";
export default {
  name: "template",
  components: {
    SpecifyShare
  },
  data() {
    let self = this
    return {
      classifyList: [],
      parentClassify: '',
      subAccountList: [{id: -1, nickname: '全部'}],
      searchForm: {
        keyword: "",
        category_id: "",
        page: 1,
        limit: 10,
      },
      tableTotal: 0,
      tableData: [],
      addDrawer: false,
      classifyProps: {
        emitPath: false,
        value: 'id',
        label: 'name'
      },
      ruleForm: {
        name:'',
        group:'',
        width: undefined,
        height: undefined,
        dpi:300,
      },
      rules: {
        name: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
        group: [{required: true, message: '请选择模板分组', trigger: 'change'}],
        width: [{required: true, validator (rule, value, callback) {
          if(!value || !self.ruleForm.height) {
            callback(new Error('请输入轮播图宽高'));
          }else {
            callback()
          }
        }, trigger: 'blur'}],
        color: [{required: true, validator (rule, value, callback) {
          if(self.colors.length) {
            callback()
          }else {
            callback(new Error('请选择颜色'));
          }
        }, trigger: 'change'}],
        dpi: [{required: true, message: '请选择模板分组', trigger: 'change'}]
      },
      dpiList:[{name:100,value:100},{name:150,value:150},{name:200,value:200},{name:250,value:250},{name:300,value:300}],
      colors: [],
      colorList: [],
      colorloading: false,
      emitChildData: [],

      dialogClassiVisible: false,
      classiForm: {
        parent_id: '',
        name: ''
      },
    };
  },
  created() {
    if(this.userRole.key != 'employee') {
      this.$set(this.searchForm, 'user_id', -1)
    }
    this.getSubList()
    this.getCategoryList();
    this.getTemplateList();
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole
    }
  },
  methods: {
    userPermission(id) {
      return this.userRole.key != 'employee' || this.$store.state.userInfo.id == id
    },
    editSoleFolder(id){
      this.$router.push({
        path: "/teamResource/template/detail",
        query: {
          id: id,
        },
      });
    },
    copyTemplate(id) {
      templateCopy(id).then(res => {
        this.$message.success('复制成功')
        this.getTemplateList()
      })
    },
    // 指定分享
    specifyShared(item) {
      //  单文件指定分享时
      if (item) {
        this.emitChildData = [item];
      } else {
        // 多文件指定分享时
        this.emitChildData = this.multipleSelection;
      }
      this.$refs.specifyShare.dialogVisible = true;
    },
    handleRemoveTemp(id, category_id) {
      const h = this.$createElement
      let selectValue = category_id
      let that = this
      this.$msgbox({
        title: '模板移动',
        message: h('el-cascader', {
          props: {
            value: selectValue,
            options: that.classifyList,
            props: {
              checkStrictly: true,
              value: 'id',
              label: 'name',
              emitPath: false
            }
          },
          ref: 'removeSelect',
          style: {width: '100%'},
          on: {
            change: (val) => {
              selectValue = val;
              // 直接更新DOM显示
              that.$refs.removeSelect.value = val
            }
          }
        }),
        showClose: false,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if(!selectValue) {
              this.$message.warning('请先选择分类');
              return false; // 阻止关闭
            }
            done();
          }else {
            done(); // 取消操作直接关闭
          }
        }
      }).then(action => {
        if (action === 'confirm') {
          templateRemoveCateg(id, {category_id: selectValue}).then(res => {
            this.$message.success('移动成功');
            this.getTemplateList()
          })
        }
      });
    },
    handleTemPubic(id, is_public) {
      templateUpdatePublic({id, is_public: is_public == 1 ? 0 : 1}).then(res => {
        this.$message.success('设置成功')
        this.getTemplateList()
      })
    },
    batchDeletion(id){
      this.$confirm('是否删除该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        templateDelete(id).then(res=>{
          if(res.code==200){
            this.getTemplateList();
          }
          this.messageBox(res);
        })
      })
    },
    editTemplateName(id) {
      this.$prompt('', '修改模板名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        inputValidator: (value) => {
          if(!value) {
            return '模板名称不能为空'
          }
        }
      }).then(({ value }) => {
        templateUpdate(id, {name: value}).then(res => {
          this.$message.success('修改成功')
          this.getTemplateList()
        })
      })

    },
    openTemplateDialog() {
      this.addDrawer = true;
      this.getColorList();
    },
    addClassify(item) {
      this.dialogClassiVisible = true
      if(item) {
        this.classiForm.id = item.id
        this.classiForm.parent_id = item.parent_id
        this.classiForm.name = item.name
      }else {
        if(this.classiForm.id) {
          delete this.classiForm.id
        }
        this.classiForm.parent_id = ''
        this.classiForm.name = ''
      }
    },
    handleClassifyConfirm() {
      if(this.classiForm.id) {
        categoryUpdate(this.classiForm.id, this.classiForm).then(res => {
          this.$message.success("修改成功");
          this.dialogClassiVisible = false
          this.getCategoryList(res.data.parent_id);
          console.log('this.parentClassify', this.parentClassify);
          
        })
      }else {
        categoryCreate(this.classiForm).then((res) => {
          this.$message.success("创建成功");
          this.dialogClassiVisible = false
          this.getCategoryList(res.data.parent_id || res.data.id);
        });
      }
      
    },
    changeCategory(item) {
      if(item === '') {
        this.parentClassify = ''
      }else if(item.parent_id == 0) {
        this.parentClassify = item
      }
      if (this.searchForm.category_id == item.id) return;
      this.searchForm.category_id = item.id;
      this.getTemplateList();
    },
    handleCategoryEdit(command, item) {
      if(command == 'delete') {
        this.$confirm('是否删除该分组?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          categoryDelete(item.id).then(res=>{
            this.getCategoryList(item.parent_id);
            this.searchForm.category_id = item.parent_id || ''
            this.messageBox(res);
          })
        })
      }else {
        this.addClassify(item)
      }
      console.log(command, item);
      
    },
    handleSubmitForm() {
      this.$refs['druleForm'].validate((valid) => {
        if (valid) {
          this.$router.push({
            path: "/teamResource/template/detail",
            query: {
              ruleForm: JSON.stringify(this.ruleForm),
              colors:JSON.stringify(this.colors),
            },
          });
        }
      });
    },
    getColorList(keyword) {
      this.colorloading = true;
      colorGetList({ keyword }).then((res) => {
        if(res.data.data.length>0){
          this.colorList = res.data.data;
        }
        this.colorloading = false;
      });
    },
    getCategoryList(parent_id) {
      categoryGetList({ page: 1, limit: 1000, tree: true }).then((res) => {
        this.classifyList = res.data;
        if(parent_id && parent_id == this.parentClassify.id) {
          this.parentClassify = res.data.find(item => item.id == parent_id)
        }
      });
    },
    setPage(v){
      this.searchForm.page=v;
      this.getTemplateList();
    },
    getTemplateList() {
      this.tableData = [];
      templateGetList(this.searchForm).then((res) => {
        this.tableData = res.data.data;
        this.tableTotal = res.data.total;
      });
    },
    getSubList() {
      allSubGetList().then(res => {
        this.subAccountList = this.subAccountList.concat(res.data)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .popper__arrow{
  display: none !important;
}
.size_option {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 30px;
  font-size: 12px;
  img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    align-self: center;
    margin-right: 11px;
  }
  .size_box1{
    align-self: center;
    display: flex;
    flex-direction: row;
  }
}
.el-dropdown-menu__item :hover{
  font-weight: bold;
}
.template_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .temp_t_btn {
      display: inline-block;
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      font-size: 20px;
      font-weight: 500;
      color: #F7F8FA;
      width: 171px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }
    .temp_classi_add {
      display: inline-block;
      margin-left: 24px;
      border-radius: 8px;
      font-size: 20px;
      font-weight: 500;
      width: 171px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      border: 1px solid #BFBFBF;
      cursor: pointer;
    }
    .temp_t_search {
      margin-right: 20px;
      display: flex;
      gap: 16px;
      /deep/ .el-input__inner {
        border-radius: 8px;
        background: #F2F3F5;
        height: 48px;
        line-height: 48px;
        border: none;
        color: #737373;
        // padding-right: 90px;
      }
    }
    .search_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
      height: 48px;
      width: 84px;
      font-size: 14px;
      color: #FFFFFF;
      border: none;
      flex-shrink: 0;
    }
  }
  .temp_classi {
    display: flex;
    align-items: center;
    gap: 28px;
    margin: 24px 0;
    .temp_classi_item {
      padding: 4px 10px;
      font-size: 16px;
      // color: #CCCCCC;
      cursor: pointer;
      span {
        font-size: 14px;
        // color: #cccccc;
      }
      .el-icon-more-outline {
        color: #737373;
        font-size: 10px;
        transform: rotate(90deg);
      }
      &.active {
        border-radius: 8px;
        background: #acaf0b;
        color: #FFFFFF;
      }
    }
  }
  .table_sucai {
    display: flex;
    width: max-content;
    img {
      width: 112px;
      height: 112px;
      margin-right: 16px;
      object-fit: contain;
      align-self: center;
    }
    .table_sucai_title {
      font-size: 16px;
      span {
        display: inline-block;
        font-size: 12px;
        border-radius: 18px;
        background: #3b4663;
        color: #ffffff;
        width: 56px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        margin-left: 8px;
      }
    }
    .table_sucai_item {
      color: #cccccc;
      display: flex;
      font-size: 12px;
      p{
        margin-right: 4px;
      }
      span {
        display: inline-block;
        align-self: center;
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
    }
  }
  .table_banner {
    width: 70%;
    img {
      width: 54px;
      height: 54px;
      margin-right: 4px;
      margin-bottom: 5px;
      object-fit: cover;
      vertical-align: middle;
    }
  }
  .form-uploader {
    height: 95px;
    border-radius: 8px;
    background: #FFFFFF;
    padding: 8px;
    border: 1px solid #525459;
    color: #e0e0e0;
    /deep/ .el-upload {
      border-radius: 4px;
      width: 100%;
      height: 100%;
      line-height: 79px;
      border: 1px dashed rgba(236, 239, 44, 0.6);
    }
  }
  .sizeform_box {
    display: flex;
    align-items: center;
    .el-input {
      width: 20%;
      /deep/ .el-input-group__prepend {
        border-radius: 8px;
        background: #FFFFFF;
        color: #ffffff;
        border: 1px solid #525459;
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        padding: 0 8px;
      }
      /deep/ .el-input__inner {
        border-left: 0 !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
      }
    }
    .sizeselect_box {
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: rgba(56, 69, 75, 0.05);
      border: 1px solid #525459;
      height: 56px;
      font-size: 12px;
      padding: 16px 8px;
      margin-left: 4%;
      .size_box {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        overflow: hidden;
      }
      .size_item {
        cursor: pointer;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid #BFBFBF;
        // background: #29334f;
        flex-shrink: 0;
        height: 24px;
        margin-left: 8px;
        padding: 0 4px;
        line-height: 24px;
        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
    }
  }
}
.color_label {
  height: 12px;
  width: 12px;
  display: inline-block;
  border: 1px solid #cdcdcd;
  margin-left: 8px;
  border-radius: 4px;
}
.temp_r_grid {
  margin-top: 32px;
  margin-bottom: 32px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 16px;
  .temp_grid_item {
    width: 19%;
    position: relative;
    background: #F7F7F7;
    .temp_printtype {
      position: absolute;
      top: 6px;
      left: 6px;
      z-index: 1;
      background: #acaf0b;
      color: #FFFFFF;
      font-size: 14px;
      padding: 4px 8px;
      border-radius: 8px;
    }
    .temp_grid_mask {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      box-shadow: 0px 0px 2px  rgba(0, 0, 0, 0.15);
      display: none;
      flex-direction: column;
      justify-content: space-between;
      .el-checkbox {
        margin-top: 16px;
        margin-left: 8px;
        /deep/ .el-checkbox__inner {
          background: transparent;
        }
        /deep/ .el-checkbox__label {
          display: none;
        }
      }
      .mask_opratebox {
        text-align: center;
        margin-top: 24%;
        img {
          cursor: pointer;
          width: 26px;
          &+img {
            margin-left: 9%;
          }
        }
        .el-dropdown {
          .el-icon-more {
            color: #FFFFFF;
            font-size: 26px;
            cursor: pointer;
          }
          &:not(:first-child) {
            margin-left: 9%;
          }
        }
      }
      .mask_textbox {
        padding: 16px;
        background: #FFFFFF;
        // color: #FFFFFF;
        font-size: 16px;
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .mask_time {
          color: #737373;
          font-size: 13px;
          margin-top: 12px;
          span {
            margin-right: 4px;
          }
          .mask_color {
            display: inline-block;
            align-self: center;
            width: 12px;
            height: 12px;
            vertical-align: middle;
            border: 1px solid #ededed;
          }
        }
      }
    }
    .temp-gridbox {
      padding: 8px;
      display: flex;
      justify-content: space-between;
      position: relative;
      .outimg_box {
        position: relative;
        width: 79%;
        height: 100%;
        &::after {
          padding-top: 100%;
          content: '';
          display: block;
        }
        .temp-grid-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        //   object-fit: contain;
        //   vertical-align: middle;
        }
      }
      .side_img_box {
        width: 18%;
        display: flex;
        flex-direction: column;
        gap: 3%;
        .side_img_out {
          width: 100%;
          position: relative;
          &::after {
            padding-top: 100%;
            content: '';
            display: block;
          }
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
    &:hover {
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.6);
      .temp_grid_mask {
        display: flex;
      }
      .temp_outname {
        background: #FFFFFF;
      }
    }
    .temp_outname {
      text-align: center;
      // margin: 8px 0;
      font-size: 14px;
      padding: 18px 0;
      font-size: 16px;
      .el-icon-edit-outline {
        cursor: pointer;
        vertical-align: middle;
      }
    }
  }
}
.el-dropdown-menu {
  // background: #151A29;
  // border: none;
  padding: 0;
  .el-dropdown-menu__item {
    // color: #FFFFFF;
    font-size: 12px;
    padding: 0 12px;
    text-align: center;
    &:focus, &:not(.is-disabled):hover {
      background: none;
    }
  }
}
</style>